import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'c-loading-login',
  templateUrl: './loading-login.component.html',
  styleUrls: ['./loading-login.component.scss']
})
export class LoadingLoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
